<div class="container-logo-steps-xs d-none d-md-none align-self-end flex-column justify-content-start align-items-end">	
  <img class="logo-img-size logo__astronaut" [src]="url_img.logo_blue" alt="">	
  <p class="paragraph-b-r-14 mb-0 m-t-5">	
    Paso <span>{{step}}</span>  de 3: <span>Sube tus documentos</span> 	
  </p>
</div>
